import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/admin/customers';
import CustomerList from './Customers';


const ms2p = (state) => {
  return {
    ...state.customers,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CustomerList);
